import "./Footer.css"
const Footer = () =>{
    return (
        <div className="footer">
        <h5>Made by Shrinkhla</h5>
        <div className="social__links">
         <a href="https://www.linkedin.com/in/shrinkhla-rajpoot-aaa74b1a7/"> <i className="fa fa-linkedin" aria-hidden="true"></i></a>
        <a href="https://github.com/Shrinkhlarajpoot" > <i className="fa fa-github" aria-hidden="true"></i></a>
         <a href="https://twitter.com/ShrinkhlaR"> <i className="fa fa-twitter" aria-hidden="true"></i></a>
          </div> 
        </div>
    )
}
export {Footer}